import { render, staticRenderFns } from "./daikuanxinxi.vue?vue&type=template&id=5f631301&scoped=true"
import script from "./daikuanxinxi.vue?vue&type=script&lang=js"
export * from "./daikuanxinxi.vue?vue&type=script&lang=js"
import style0 from "./daikuanxinxi.vue?vue&type=style&index=0&id=5f631301&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f631301",
  null
  
)

export default component.exports